import { getClientType } from '../../../tools/session/clientSession';
import { httpGet, httpPost } from '../../../tools/http/httpClient';

export function calculateGreenWave(requestBody) {
  return httpPost('/api/calcola_onda_verde', {
    ...requestBody,
    client_type: requestBody.client_type || getClientType(),
  }, { loadingKey: 'tl-green-wave' });
}

export function fetchTrafficLights(bbox) {
  return httpGet(`/api/traffic_lights?bbox=${encodeURIComponent(bbox)}`, { loadingKey: 'traffic-lights' });
}
